export const environment = {
  production: true,
  apiUrl: '/api',
  appName: 'Shell Muze Admin',
  envName: 'production',
  envLabel: 'PRODUCTION',
  envColor: '#EF4444',   // red
  googleClientId: '499104159171-qf8hed34upetihevjvqscgntpoe69nqp.apps.googleusercontent.com'
};
